import { Logger } from '@futrli/shared-services';
import { toastError } from '@futrli/ui-components';

import { findNormalisedErrorByMessage } from './normalised-errors';

export const addNormalisedErrorMessage = () => (error: Error) => {
  const normalisedError = findNormalisedErrorByMessage(error);

  Logger.error(normalisedError ? normalisedError.defaultMessage : error.message);
  toastError(normalisedError ? normalisedError.defaultMessage : error.message);
};
